export const sizes = {
  xs: 480,
  md: 768,
  lg: 1024,
  xl: 1250
};
export const breakpoints = {
  xs: `@media (min-width: ${sizes.xs}px)`,
  md: `@media (min-width: ${sizes.md}px)`,
  lg: `@media (min-width: ${sizes.lg}px)`,
  xl: `@media (min-width: ${sizes.xl}px)`
};